import { addMinuteSecond } from './addMinuteSecond';

export const generateTimeScale = (start: number, end: number): string[] => {
  const result: string[] = [addMinuteSecond(start)];

  while (result[result.length - 1] !== addMinuteSecond(end)) {
    result.push(addMinuteSecond(++start));
  }

  return result;
};
